import { DashboardWidgetWidth } from '../model';

export function dashboardWidgetWidthClassName(
  width: DashboardWidgetWidth,
  twoPerMobileRow = false,
) {
  const mobileSpan = twoPerMobileRow ? 'col-span-1' : 'col-span-2';
  switch (width) {
    case DashboardWidgetWidth.Quarter:
      return `min-w-0 ${mobileSpan} md:col-span-3`;
    case DashboardWidgetWidth.Third:
      return `min-w-0 ${mobileSpan} md:col-span-4`;
    case DashboardWidgetWidth.Half:
      return `min-w-0 ${mobileSpan} md:col-span-6`;
    case DashboardWidgetWidth.Full:
      return `min-w-0 ${mobileSpan} md:col-span-12`;
    case DashboardWidgetWidth.Sixth:
      return 'min-w-0 col-span-1 md:col-span-4 @min-[56rem]/dashboard:col-span-2';
  }
}
